<template>
    <div class='vx-col w-full mt-4'>
         <!--button regresar-->
         <vs-button color="#f5f5f5" style="color:#1872DF;" class="vs-button p-2" @click="$emit('changeHandle',0);">← Volver</vs-button>
        <section class="botonera mt-3">
            <vs-button class="m-1"  @click="menu = 0;">Encabezado</vs-button>
            <vs-button color="dark" @click="menu = 1;" class="m-1">Preguntas del desafío</vs-button>
        </section>
        <vs-divider></vs-divider>
        <!--====ENCABEZADO======-->
        <section class="encabezado" v-if="menu == 0">
            <div class="vx-row mt-3">
                <div class="vx-col sm:w-1/2 xs:w-1/1 w-full">
                    <p>Seleccionar libro</p>
                    <v-select class="mb-3 w-full" :disabled="deshabilitado" v-model="libroSelect" :options="arregloLibros" :reduce="arregloLibros => arregloLibros.idlibro" label="nombrelibro" @input="cargarCursos()" />
                </div>
                <div class="vx-col sm:w-1/2 xs:w-1/1 w-full">
                    <p>Seleccionar curso</p>
                    <v-select class="mb-3 w-full" v-model="cursoSelect" :options="arregloCursos" :reduce="arregloCursos => arregloCursos" label="cursoparalelo" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Fecha inicio</div>
                    <flat-pickr class="w-full" :config="configdateTimePicker" v-model="datos.fecha_inicio" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Fecha fin</div>
                    <flat-pickr class="w-full" :config="configdateTimePicker" v-model="datos.fecha_fin" />
                </div>
                <div class="vx-col sm:w-1/2 xs:w-1/1 w-full">
                    <p>Origen de las preguntas</p>
                    <v-select class="mb-3 w-full" v-model="origenSelect" :options="preguntasFrom" :reduce="preguntasFrom => preguntasFrom.id" label="nombre" />
                    <!-- {{origenSelect}} -->
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Puntaje</div>
                    <vs-input type="number" min="0" max="100" class="w-full" v-model="datos.puntaje" placeholder="maximo puntaje a calificar"></vs-input>
                </div>
                <div class="vx-col sm:w-1/2 xs:w-1/1 w-full">
                    <p>De cuántas unidades desea cargar las preguntas</p>
                    <v-select class="mb-3 w-full" multiple v-model="unidadSelect" :options="unidades" :reduce="unidades => unidades" label="nombre" />
                    <!-- {{ unidadSelect }} -->
                </div>
                <div class="vx-col sm:w-1/2 xs:w-1/1 w-full">
                    <p>Grupos de evaluación</p>
                    <v-select class="mb-3 w-full" v-model="grupoSelect" :options="grupos" :reduce="grupos => grupos.id" label="nombre" />
                </div>
                <!--intentos-->
                <div class="vx-col sm:w-1/2 w-full mb-3">                        
                    <div style="color: gray; font-size: 12px;">Intentos:</div>
                    <vs-input type="number" min="1" max="5" class="w-full" v-model="datos.intentos" placeholder="maximo intentos"></vs-input>
                </div>
                <!--tipo calificacion-->
                <div class="vx-col sm:w-1/2 w-full mb-3" v-if="datos.intentos > 1">
                    <div style="color: gray; font-size: 12px;">Calificación</div>
                    <vs-radio class="m-2" v-model="datos.tipo_calificacion" vs-name="radiotipo_calificacion" vs-value="1">Nota más alta de intentos</vs-radio>
                    <vs-radio class="m-2" v-model="datos.tipo_calificacion" vs-name="radiotipo_calificacion" vs-value="0">Promediar intentos</vs-radio>
                </div>
                <!--permitir  abandonar-->
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Permitir abandonar el desafío</div>
                    <vs-radio class="m-2" v-model="datos.permitir_salir_evaluacion" vs-name="radiopermitir_salir_evaluacion" vs-value="1">Si</vs-radio>
                    <vs-radio class="m-2" v-model="datos.permitir_salir_evaluacion" vs-name="radiopermitir_salir_evaluacion" vs-value="0">No</vs-radio>
                </div>
                <!--Cantidad de veces abandonar-->
                <div class="vx-col sm:w-1/2 w-full mb-3" v-if="datos.permitir_salir_evaluacion == 1">                        
                    <div style="color: gray; font-size: 12px;">Cantidad de veces que puede abandonar el desafío:</div>
                    <vs-input type="number" min="2" max="5" class="w-full" v-model="datos.cantidad_abandonar" placeholder="cantidad_abandonar"></vs-input>
                </div>
                <!--tiempo evaluacion-->
                <div class="vx-col sm:w-1/2 w-full mb-3">                        
                    <div style="color: gray; font-size: 12px;">Duración:</div>
                    <vs-input type="number" min="2" max="600" class="w-full" v-model="datos.tiempo" placeholder="Tiempo"></vs-input>
                </div>
                <!--add question open-->
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Agregar una pregunta abierta:</div>
                    <vs-radio class="m-2" v-model="datos.agregar_pregunta_abierta" vs-name="radioagregar_pregunta_abierta" vs-value="1">Si</vs-radio>
                    <vs-radio class="m-2" v-model="datos.agregar_pregunta_abierta" vs-name="radioagregar_pregunta_abierta" vs-value="0">No</vs-radio>
                </div>
                <!--mostrar las respuestas de los estudiantes-->
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Mostrar las respuestas a los estudiantes</div>
                    <vs-radio class="m-2" v-model="datos.respuestas" vs-name="radioRespuestas" vs-value="1">Si</vs-radio>
                    <vs-radio class="m-2" color="success" v-model="datos.respuestas" vs-name="radioRespuestas" vs-value="0">No</vs-radio>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Estado</div>
                    <vs-radio class="m-2" color="success" v-model="datos.estado" vs-name="radioestado" vs-value="1">Activa</vs-radio>
                    <vs-radio class="m-2" v-model="datos.estado" vs-name="radioestado" vs-value="0">Inactiva</vs-radio>
                </div>
                <div class="vx-col w-full mb-3">
                    <div style="color: gray; font-size: 12px;">Indicaciones generales</div>
                    <vs-textarea v-model="datos.indicaciones" rows="4" placeholder="indicaciones para tomar en cuenta en la evaluación de los estudiantes."></vs-textarea>
                </div>
                <div class="vx-col w-full mb-3">
                    <vs-button @click="f_guardar_editar();" :color="propiedades.color_boton"> {{ propiedades.txt_boton }} </vs-button>
                </div>
            </div>
        </section>
        <!--====PREGUNTAS========-->
        <section class="Preguntas" v-if="menu == 1">
            <div v-if="id == 0">
                <vs-alert>Guarde primero el desafío</vs-alert>
            </div>
            <div v-else>
                <DocenteScreenEvaluacionVue :id="id" :ObjectSelected="ObjectSelected" :unidadSelect="unidadSelect"/>
            </div>
        </section>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import GeneralMixin from '../../../mixins/GeneralMixin';
const DocenteScreenEvaluacionVue = () => import('./components/DocenteScreenEvaluacion.vue')
export default {
    mixins: [GeneralMixin],
    components: {
        vSelect,
        flatPickr,
        DocenteScreenEvaluacionVue,
    },
    data() {
        return {
            deshabilitado:'',
            menu:0,
            usuario: [],
            periodo_actual: '',
            arregloLibros: [],
            libroSelect: '',
            arregloCursos: [],
            cursoSelect: '',
            unidades: [{
                    'id': 1,
                    'nombre': 'Unidad 1',
                },
                {
                    'id': 2,
                    'nombre': 'Unidad 2',
                },
                {
                    'id': 3,
                    'nombre': 'Unidad 3',
                },
                {
                    'id': 4,
                    'nombre': 'Unidad 4',
                },
                {
                    'id': 5,
                    'nombre': 'Unidad 5',
                },
                {
                    'id': 6,
                    'nombre': 'Unidad 6',
                },
                {
                    'id': 7,
                    'nombre': 'Unidad 7',
                },
                {
                    'id': 8,
                    'nombre': 'Unidad 8',
                },
                {
                    'id': 9,
                    'nombre': 'Unidad 9',
                },
                {
                    'id': 10,
                    'nombre': 'Unidad 10',
                },
            ],
            unidadSelect: [],
            grupos: [{
                    'id': 1,
                    'nombre': '1 grupo'
                },
                {
                    'id': 2,
                    'nombre': '2 grupos'
                },
                {
                    'id': 3,
                    'nombre': '3 grupos'
                },
                {
                    'id': 4,
                    'nombre': '4 grupos'
                },
            ],
            grupoSelect: '',
            preguntasFrom: [{
                'id': 0,
                'nombre': 'Desafios AZ' //preguntas cargadas por la administracion
            }, {
                'id': 1,
                'nombre': 'Mis desafíos' //preguntas creadas por el DOCENTE
            }],
            origenSelect: '',
            configdateTimePicker: {
                enableTime: true,
                altFormat: 'Y-M-d H:i',
                dateFormat: 'Y-m-d H:i'
                // minDate: "today", //fecha minima
                // mode: "range", //rango              
            },
            datos: {
                'id': 0,
                'puntaje': '10',
                'fecha_inicio': '',
                'fecha_fin': '',
                'respuestas': 1,
                'indicaciones': '',
                'estado': 1,
                'intentos':2,
                'agregar_pregunta_abierta': 0,
                'permitir_salir_evaluacion': 0,
                'cantidad_abandonar':2,
                'tiempo': 60,
                'tipo_calificacion': 0,
            },
            propiedades: {
                'txt_boton': '',
                'color_boton': '',
                'type_boton': '',
            },
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        me.periodo_actual = localStorage.periodo_id;
        // console.log(me.usuario, me.periodo_actual)
        me.f_inicio();
        me.getLibros();
    },
    props:{
        id:             { type: Number, default: 0 },
        ObjectSelected: { type: Object, default: () => {} }
    },
    watch: {
        id(){
            this.f_inicio()
        },
    },
    methods: {
        f_inicio() {
            let me = this;
            if(this.ObjectSelected.id > 0) {
                me.deshabilitado = true;
            }else{
                me.deshabilitado = false;
            }
            me.propiedades = {
                'txt_boton': 'Guardar',
                'color_boton': 'primary',
                'type_boton': 'relief',
            }
            //editar
            if(me.id > 0){
                me.unidadSelect   = [];
                me.datos = {
                    'id':                       me.ObjectSelected.id,
                    'puntaje':                  me.ObjectSelected.puntaje,
                    'fecha_inicio':             me.ObjectSelected.fecha_inicio,
                    'fecha_fin':                me.ObjectSelected.fecha_fin,
                    'respuestas':               me.ObjectSelected.respuestas,
                    'indicaciones':             me.ObjectSelected.indicaciones,
                    'intentos':                 me.ObjectSelected.intentos,
                    'agregar_pregunta_abierta': me.ObjectSelected.agregar_pregunta_abierta,
                    'permitir_salir_evaluacion':me.ObjectSelected.permitir_salir_evaluacion,
                    'cantidad_abandonar':       me.ObjectSelected.cantidad_abandonar,
                    'tiempo':                   me.ObjectSelected.tiempo,
                    'tipo_calificacion':        me.ObjectSelected.tipo_calificacion,
                    'estado':                   me.ObjectSelected.estado,
                }
                me.libroSelect   =              me.ObjectSelected.idlibro;
                me.origenSelect  =              me.ObjectSelected.origen;
                me.grupoSelect   =              me.ObjectSelected.grupos;
                //separar las unidades que tiene la coma
                let preunidades  =              me.ObjectSelected.unidades.split(',');
                //agregar un array de objeto con id el numero de la unidad y un propiedad nombre unidad concatenado el numero de la unidad
                preunidades.forEach( x => {
                    me.unidadSelect.push({
                        'id': x,
                        'nombre': 'Unidad ' + x
                    })
                })
                me.cargarCursos()
                me.cursoSelect = me.ObjectSelected.curso
                //agrega la propiedad cursoparalelo al objeto cursoSelect
                me.cursoSelect.cursoparalelo = "Paralelo "+me.ObjectSelected.curso.paralelo +" - "+me.ObjectSelected.curso.codigo    
            }
            //save
            else{
                me.datos = {
                    'id': 0,
                    'puntaje': '10',
                    'fecha_inicio': '',
                    'fecha_fin': '',
                    'respuestas': 1,
                    'indicaciones': '',
                    'intentos':2,
                    'agregar_pregunta_abierta': 0,
                    'permitir_salir_evaluacion': 0, //0 = 'No', 1 = 'Si
                    'cantidad_abandonar':2,
                    'tiempo': 60,
                    'tipo_calificacion': 0,
                    'estado': 1,
                },
                me.libroSelect  = '';
                me.cursoSelect  = '';
                me.origenSelect = '';
                me.grupoSelect  = '';
            }
        },
        async getLibros() {
            let me = this;
            me.libros_area = []
            me.$vs.loading();
            await this.$http.get(this.$server_url + 'getLibrosDocentesEvaluacion/' + me.usuario.idusuario + '/' + me.periodo_actual)
                .then(function (res) {
                    console.log(res.data)
                    me.arregloLibros = res.data
                    me.$vs.loading.close();
                })
        },
        cargarCursos() {
            let me = this;
            // return
            me.cursoSelect = '';
            me.$vs.loading()
            let data = new FormData();
            data.append('id_usuario',   me.usuario.idusuario);
            data.append('id_libro',     me.libroSelect);
            data.append('periodo_id',   localStorage.periodo_id);
            this.$http.post(this.$server_url + 'curso_libro_docente_Evaluacion', data)
                .then(function (response) {
                    console.log('arreglo cursos',response.data);
                    me.arregloCursos = response.data;
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        f_guardar_editar() {
            let me = this;

            if (me.libroSelect == null || me.libroSelect == undefined) {
                me.f_notificaciones('Seleccione un libro', 'warning');
                return;
            }
            if (me.cursoSelect.idcurso == null || me.cursoSelect.idcurso == undefined) {
                me.f_notificaciones('Seleccione un curso', 'warning');
                return;
            }
            if (me.datos.fecha_inicio == "" || me.datos.fecha_inicio == undefined) {
                me.f_notificaciones('Seleccione una fecha de inicio', 'warning');
                return;
            }
            if (me.datos.fecha_fin == "" || me.datos.fecha_fin == undefined) {
                me.f_notificaciones('Seleccione una fecha de finalización', 'warning');
                return;
            }
            if (me.origenSelect == null || me.origenSelect == undefined) {
                me.f_notificaciones('Seleccione la fuente de las preguntas', 'warning');
                return;
            }
            if (me.datos.puntaje == "" || me.datos.puntaje > 100 || me.datos.puntaje < 0) {
                me.f_notificaciones('Ingrese el puntaje', 'warning');
                return;
            }
            if (me.datos.estado == null || me.datos.estado == undefined || me.datos.estado == "") {
                me.f_notificaciones('Seleccione el estado', 'warning');
                return;
            }
            if (me.datos.indicaciones == null || me.datos.indicaciones == undefined || me.datos.indicaciones == "") {
                me.f_notificaciones('Ingrese las indicaciones para la evaluación.', 'warning');
                return;
            }
            if(me.grupoSelect == null || me.grupoSelect == undefined){
                me.f_notificaciones('Seleccione el tipo de evaluación', 'warning');
                return;
            }
            if(me.unidadSelect == null || me.unidadSelect == undefined){
                me.f_notificaciones('Seleccione las unidades de las que desea cargar las preguntas', 'warning');
                return;
            }
            //unidades
            var idunidades = [];
            for( var i=0; i<this.unidadSelect.length; i++ ){
                idunidades.push(this.unidadSelect[i].id);
            }

            let data = new FormData();
            data.append('id',                       me.datos.id);
            data.append('idlibro',                  me.libroSelect);
            data.append('idperiodo',                me.periodo_actual);
            data.append('ideditor',                 me.usuario.idusuario);
            data.append('idgrupo',                  me.usuario.id_group);
            data.append('idcurso',                  me.cursoSelect.idcurso);
            data.append('codigo_curso',             me.cursoSelect.codigo);
            data.append('indicaciones',             me.datos.indicaciones);
            data.append('puntaje',                  me.datos.puntaje);
            data.append('fecha_inicio',             me.datos.fecha_inicio);
            data.append('fecha_fin',                me.datos.fecha_fin);
            data.append('estado',                   me.datos.estado);
            data.append('origen',                   me.origenSelect);
            data.append('grupos',                   me.grupoSelect);
            data.append('unidades',                 idunidades);
            data.append('respuestas',               me.datos.respuestas);
            data.append('intentos',                 me.datos.intentos);
            data.append('agregar_pregunta_abierta', me.datos.agregar_pregunta_abierta);
            data.append('permitir_salir_evaluacion',me.datos.permitir_salir_evaluacion);
            data.append('cantidad_abandonar',       me.datos.cantidad_abandonar);
            data.append('tiempo',                   me.datos.tiempo);
            data.append('tipo_calificacion',        me.datos.tipo_calificacion);
            me.$vs.loading();
            this.$http.post(this.$server_url + 'evaluacion', data)
                .then(function (response) {
                    me.$emit('changeHandle', 1, response.data)
                    me.f_notificaciones('Evaluación registrada correctamente', 'success');
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()
                    me.f_notificaciones('Error al registrar la evaluación', 'danger');
                })
        }
    }
};
</script>
